import MobileDrawer from '@c/drawers/MobileDrawer';
import OfferOperationContent from './OfferOperationContent';
import { OfferDocument } from 'models/offer';

interface MobileOfferOperationModalProps {
  show: boolean;
  dismiss: () => void;
  type: 'counter' | 'accept' | 'decline';
  offer: OfferDocument;
}

export default function MobileOfferOperationModal({
  show,
  dismiss,
  type,
  offer,
}: MobileOfferOperationModalProps) {
  return (
    <MobileDrawer show={show} dismiss={dismiss} hideCloseButton>
      <div className="overflow-y-hidden pt-12">
        <OfferOperationContent
          type={type}
          offer={offer}
          onClose={dismiss}
          showTitle={false}
          hideCloseButton={true}
        />
      </div>
    </MobileDrawer>
  );
}
